<template>
    <div  class="Basis-box">
        <el-form  :model="form" label-width="80px">
            <div class="grouping">
                <div class="grouping-left">
                    <el-form-item label="（类型）分组" :label-width="formLabelWidth">
                        <el-select v-model="form.type" placeholder="请选择分组">
                            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value">{{item.label}}</el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-show="form.type==1" class="grouping-right">
                    <el-form-item label="价格">
                        <el-input v-model="form.price" placeholder="请输入价格"></el-input>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="测评名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" placeholder="请输入测评名称"></el-input>
            </el-form-item>
            <el-form-item label="别名" :label-width="formLabelWidth">
                <el-input v-model="form.alias_name" autocomplete="off" placeholder="请输入别名"></el-input>
            </el-form-item>
            <el-form-item label="永久链接" :label-width="formLabelWidth">
                <el-input v-model="form.url" autocomplete="off" placeholder="请输入永久链接"></el-input>
            </el-form-item>
            <!-- 上传图片 -->
            <el-form-item  label="上传图片" :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <!--  -->
                <el-image class="up-image" :src="form.imgurl">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" :style="{height:basis_src?'':'150px','line-height':basis_src?'':'150px'}" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!--  -->
            <el-form-item  label="描述摘要" :label-width="formLabelWidth">
                <el-input v-model="form.describe"  type="textarea" :rows="4" autocomplete="off" placeholder="请输入描述摘要"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item :label-width="formLabelWidth">
                <el-button type="primary" @click="vailBasis">保存</el-button>
                <el-button @click="$router.go(-1)">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { evaluationAdd,upload_image,evaluationEdit } from "@/api/measurement";

export default {
    data() {
        return{
            formLabelWidth: '130px',
            options:[
                {label:'免费测试',value:0},
                {label:'收费测试',value:1}
            ],
            form:{
                type:null,
                price:null,
                url:'',
                name:'',
                alias_name:'',
                imgurl:'',
                describe:''
            }
        }
    },
    props:['id'],
    methods:{
        // 获取基础信息
        findBasisHandle(){
            evaluationEdit({
                id:this.id
            }).then((data)=>{
                this.form = data.data;
            });
        },
        pullData(){
            if(this.$route.query.type=='edit'){
                this.findBasisHandle();
            }
        },
        // 验证
        vailBasis(val){
            if(this.form.name){
                this.saveBasis();
            }else{
                this.$message({
                    message: '名称不能为空！',
                    type: 'warning'
                });
            }
        },
        // 提交基础信息
        saveBasis(){
            let obj = {
                imgurl:this.form.imgurl,
                type:this.form.type,
                price:this.form.type==1?this.form.price:null,
                url:this.form.url,
                name:this.form.name,
                alias_name:this.form.alias_name,
                imgurl:this.form.imgurl,
                describe:this.form.describe 
            };
            // 如果是修改就传id
            let title = '添加';
            if(this.$route.query.type=='edit'){
                obj.id = this.id;
                title = '修改';
            }
            evaluationAdd(obj).then((data)=>{
                this.$confirm('保存成功, 是否继续'+title+'其它信息?', '提示', {
                    confirmButtonText: '下一步',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((data) => {
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    // 把成功后的结果传给父组件
                    let res = {
                        id:data.id,
                        bool:false
                    };
                    this.$emit('basisSuccessHandle',res);
                });

            });
        },
        beforeAvatarUpload(file) {
            const isJPG = true;
            const isLt2M = file.size / 1024/ 1024  < 1;

            if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif' ) {
                isJPG = false;
                this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        uploadImg(param){
            // FormData 对象
            let form = new FormData();
            // 文件对象
            form.append("image", param.file);
            // 携带当前讲座的id
            form.append("key", this.$route.path);
            form.append("preserve", 1);

            // 上传图片接口
            upload_image(form).then((data)=>{
                this.form.imgurl = data.image_url;
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.Basis-box{
    .el-input,.el-textarea{
        width:775px;
    }
    .grouping{
        width:100%;
        .grouping-left,.grouping-right{
            width: 50%;
            display: inline-block;
        }
        .grouping-right .el-input{
            width: 250px;
        }
    }
}
.up-image{
    margin: 20px auto auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}
</style>
